import * as React from "react";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
const SvgClouds = (props) => /* @__PURE__ */ _jsxs("svg", {
	xmlns: "http://www.w3.org/2000/svg",
	width: 344,
	height: 118,
	fill: "none",
	viewBox: "0 0 344 118",
	...props,
	children: [
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M212.5 0a46.5 46.5 0 0 0-44 31.42A29.5 29.5 0 0 0 134.96 68H323l.01-.5a13.5 13.5 0 0 0-21.52-10.86 18.5 18.5 0 0 0-19.75-7.02 18.5 18.5 0 0 0-23.02-8.33A46.5 46.5 0 0 0 212.5 0"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 224,
			height: 4,
			fill: "#fff",
			rx: 2,
			transform: "matrix(-1 0 0 1 344 68)"
		}),
		/* @__PURE__ */ _jsx("path", {
			fill: "#fff",
			d: "M85.12 84c13.21 0 24.43 6.08 28.48 14.55q1.59-.2 3.24-.2c10.55 0 19.1 6.12 19.1 13.66q0 1.8-.63 3.47H13.61l-.02-.23c0-3.45 3.92-6.25 8.74-6.25 1.95 0 3.74.46 5.2 1.23 2.17-2.15 5.7-3.54 9.7-3.54q1.6 0 3.08.29c2.03-2.66 5.97-4.46 10.5-4.46q2.35 0 4.4.6C56.9 92.36 69.64 84 85.12 84"
		}),
		/* @__PURE__ */ _jsx("rect", {
			width: 145,
			height: 1.85,
			y: 115.48,
			fill: "#fff",
			rx: .93
		})
	]
});
export default SvgClouds;
